import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthIntervenienteComponent } from '../auth/pages/auth-interveniente/auth-interveniente.component';
import { AuthRoutingModule } from '../auth/routes/auth.routing.module';
import { AcessGuard } from '../auth/services/acess.guard.service';
import { AuthGuardService } from '../auth/services/auth.guard.service';
import { IntervenienteLiquidanteModule } from '../interveniente-liquidante/interveniente-liquidante.module';
import { RelatorioPagamentoDecendialComponent } from '../interveniente-liquidante/pages/relatorio-pagamento-decendial/relatorio-pagamento-decendial.component';
import { PortalRoutingModule } from '../portal/routes/portal.routing.module';
import { HomeComponent } from '../shared/pages/home/home.component';

const routes: Routes = [
    { path: 'home/investidores', component: HomeComponent},
    { path: 'login', component: HomeComponent},
    { path: '',component: HomeComponent},
    {
      path: "spg",
      pathMatch: 'prefix',
      // canLoad: [AcessGuard],
      // canActivate: [AuthGuardService],
      loadChildren: () => import('../portal/portal.module').then(e => e.PortalModule)
    },
    // {
    //     path: 'home/interveniente',
    //     component: AuthIntervenienteComponent,
    // },
    // {
    //     path: 'interveniente-liquidante',
    //     component: RelatorioPagamentoDecendialComponent,
    //     loadChildren: () => import('../portal/portal.module').then(e => e.PortalModule)

    // },
    { path: '**', redirectTo: 'home/investidores', pathMatch: 'prefix' },
];

@NgModule({
    imports: [
        AuthRoutingModule,
        PortalRoutingModule,
        IntervenienteLiquidanteModule,
        RouterModule.forRoot(routes, { useHash: true })
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {

}
